var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSyncIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_474_3",
    "data-name": "Component 474 \\u2013 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9550",
    "data-name": "Group 9550",
    transform: "translate(-1753 -116)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_106",
    "data-name": "Ellipse 106",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(1753 116)",
    fill: "#ecedf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "noun-refresh-5434738",
    d: "M118.266,54.67h-1.6a7.986,7.986,0,0,1,13.6-5.694V47.47h1.6v4a.8.8,0,0,1-.8.8h-4v-1.6h2.578a6.388,6.388,0,0,0-11.378,4Zm12.8,0h0a6.388,6.388,0,0,1-11.377,4h2.577v-1.6h-4a.8.8,0,0,0-.8.8v4h1.6V60.364a7.986,7.986,0,0,0,13.6-5.694Z",
    transform: "translate(1640.334 73.33)",
    fill: "#434db8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncIcon);
export default __webpack_public_path__ + "static/media/syncIcon.160639857cbbd1d438d9ebbbe8543796.svg";
export { ForwardRef as ReactComponent };